(function () {
  'use strict';

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return 'R' + (cents / 100).toFixed(2);
  }

  function initStickyAtc() {
    var bar = document.getElementById('ShStickyAtc');
    var btn = document.getElementById('ShStickyAtcBtn');
    var priceEl = document.getElementById('ShStickyAtcPrice');
    if (!bar || !btn) return;

    var form = document.querySelector('form[action*="/cart/add"]');
    var mainBtn = form && form.querySelector('[name="add"]');
    if (!form || !mainBtn) return;

    bar.hidden = false;

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries[0] && entries[0].isIntersecting;
        bar.classList.toggle('sh-sticky-atc--visible', !visible);
      },
      { root: null, threshold: 0, rootMargin: '0px 0px -15% 0px' }
    );
    observer.observe(mainBtn);

    btn.addEventListener('click', function () {
      if (mainBtn.disabled) return;
      mainBtn.click();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event.data && event.data.variant;
        if (!variant) return;
        if (priceEl && variant.price != null) {
          priceEl.textContent = formatMoney(variant.price);
        }
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
})();
